/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";

import { IoEye } from "react-icons/io5";

import { formatDate } from "../../../helpers/date";
import StyledTextCell from "../../tableFields/StyledTextCell";

export const SUMMARY_COLUMNS = [
  {
    id: "callType",
    accessor: "callType",
    Header: "Call Type",
    maxWidth: 120
  },
  {
    id: "billable_hrs",
    accessor: "billable_hrs",
    Header: "Total Billed",
    maxWidth: 100,
    Cell: ({ value }) => (
      <StyledTextCell
        getValue={(val) => (typeof val === "number" ? val.toFixed(1) : null)}
        value={value || 0}
        style={{ color: "red" }}
      />
    )
  }
];

export const TIME_SUMMARY_COLUMNS = [
  // {
  //   id: "number",
  //   accessor: "number",
  //   Header: "Number",
  //   maxWidth: 150
  // },
  {
    id: "date",
    accessor: "date",
    Header: "Date",
    maxWidth: 100,
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yy") : null)
  },
  {
    id: "employee",
    accessor: "employee",
    Header: "Employee",
    maxWidth: 150
  },
  {
    id: "callType",
    accessor: "callType",
    Header: "Call Type",
    maxWidth: 120
  },
  {
    id: "department",
    accessor: "department",
    Header: "Department",
    maxWidth: 100
  },
  {
    id: "billable_hrs",
    accessor: "billable_hrs",
    Header: "Total Billed",
    maxWidth: 100,
    Cell: (row) => {
      const data = row.original ? row.original : row.row?.original;
      return (
        <StyledTextCell
          getValue={(val) => (typeof val === "number" ? val.toFixed(1) : null)}
          value={row.value || 0}
          style={data?.id ? {} : { fontWeight: "bold" }}
        />
      );
    }
  },
  {
    id: "project",
    accessor: "project",
    Header: "Project",
    maxWidth: 250,
    Cell: (row) => {
      const data = row.original ? row.original : row.row?.original;
      return (
        <StyledTextCell
          getValue={(val) => val || ""}
          value={row.value || 0}
          style={data?.id ? {} : { fontWeight: "bold" }}
        />
      );
    }
  },
  {
    id: "description",
    accessor: "description",
    Header: "Description"
  },
  {
    id: "id",
    accessor: "id",
    Header: "",
    maxWidth: 40,
    Cell: ({ value }) =>
      value ? (
        <a
          href={`/app/calls/${value}`}
          target="_blank"
          rel="noopener noreferrer"
          className="link-icon"
        >
          <IoEye size="sm" />
        </a>
      ) : null
  }
];
